import {
  Box_default
} from "./chunk-GDQZHQO7.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/layout/FullBox.tsx
import React, { forwardRef } from "react";
var FullBox = forwardRef((_a, forwardedRef) => {
  var _b = _a, { align, alignY } = _b, props = __objRest(_b, ["align", "alignY"]);
  return /* @__PURE__ */ React.createElement(Box_default, __spreadProps(__spreadValues({
    display: "flexRow",
    boxHeight: "full",
    boxWidth: "full",
    alignItems: alignY,
    justifyContent: align
  }, props), {
    ref: forwardedRef
  }));
});

export {
  FullBox
};
//# sourceMappingURL=chunk-C2USQR22.js.map
